// directives/observable.ts
import { nothing } from "lit";
import { AsyncDirective, directive } from "lit/async-directive.js";
var ObservableDirective = class extends AsyncDirective {
  render(obs2) {
    this._obs = obs2;
    this._startSubscription();
    return this.currVal ?? nothing;
  }
  disconnected() {
    if (this._subscription)
      this._subscription.unsubscribe();
    this._subscription = void 0;
  }
  reconnected() {
    this._startSubscription();
  }
  _startSubscription() {
    if (this._subscription)
      return;
    this._subscription = this._obs.subscribe((renderable) => this.setValue(renderable));
  }
  // need this to catch rerenders of surrounding webcomponent
  setValue(value) {
    this.currVal = value;
    return super.setValue(value);
  }
};
var obs = directive(ObservableDirective);
export {
  ObservableDirective,
  obs
};
